import { Link } from "react-router";

export function NotFoundPage() {
  return (
    <div className="bg-bg flex min-h-screen flex-col items-center justify-center px-4">
      <h1 className="font-display text-fg leading-display text-6xl font-normal">404</h1>
      <p className="text-fg-muted mt-4 text-lg">Page not found</p>
      <Link
        to="/queue"
        className="bg-accent text-accent-fg hover:bg-accent-hover mt-8 rounded-md px-6 py-2 text-sm font-medium"
      >
        Go to the queue
      </Link>
    </div>
  );
}
